import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useNotificationStore } from "stores/notifications";
import PropTypes from "prop-types";
import { useMutation } from "react-query";

export const declineBid = ({ id }) => {
  return axios.post(`/bids/${id}/decline`);
};

declineBid.propTypes = {
  id: PropTypes.string.isRequired,
};

export const useDeclineBid = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    onMutate: async (declinedBid) => {
      await queryClient.cancelQueries("buyerbids");

      const previousBids = queryClient.getQueryData("buyerbids");

      queryClient.setQueryData(
        "buyerbids",
        previousBids?.filter((bid) => bid.id !== declinedBid.id)
      );

      return { previousBids };
    },
    onError: (_, __, context) => {
      if (context?.previousBids) {
        queryClient.setQueryData("buyerbids", context.previousBids);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries("buyerbids");
      addNotification({
        type: "success",
        title: "Bid has been denied",
      });
    },
    ...config,
    mutationFn: declineBid,
  });
};
